import { DatePicker, TimePicker } from "antd";
import React from "react";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

interface UnitFormProps {
  handleSubmit: (e: any) => void;
  onCloseModal: (e: any) => void;
  updateSubunit: (e: any) => void;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setErrors: React.Dispatch<React.SetStateAction<any>>;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  isEditForm: boolean;
  open: boolean;
  formData: any;
  errors: any;
  // isUpdate: boolean;
  isSubmittingForm: boolean;
  fileRef?: React.RefObject<HTMLInputElement>;
}

const SubunitForm: React.FC<UnitFormProps> = ({
  fileRef,
  formData,
  setFormData,
  handleChange,
  handleSubmit,
  updateSubunit,
  errors,
  setErrors,
  isSubmittingForm,
  onCloseModal,
  open,
  isEditForm,
}) => {
  return (
    <div>
      {/* <Modal open={open} onClose={onCloseModal} center styles={{}} > */}
      <div className="p-md-3 ">
        <h3 className="mb-4 pb-1 text-cente">
          <strong>{isEditForm ? "Edit Subunit" : "Add Subunit"}</strong>
        </h3>

        <form
          onSubmit={(e) => {
            isEditForm ? updateSubunit(e) : handleSubmit(e);
          }}
        >
          <div className="row p-0 px-md-3">
            {/* Title */}
            <div className="col-md-12 mb-3">
              <label>
                <strong>
                  Lesson Sub-unit<sup className="text-danger">*</sup>
                </strong>
              </label>
              <input
                type="text"
                name="subunit_desc"
                value={formData.subunit_desc}
                onChange={handleChange}
                className="form-control mt-1"
                placeholder="Enter Sub-unit name"
              />
              {errors?.subunit_desc && (
                <p className="p-0 ps-1 pt-1 text-danger">
                  {errors?.subunit_desc}
                </p>
              )}
            </div>

            {/* Planned On */}
            <div className="col-md-6 mb-3">
              <label>
                <strong>
                  Date of Class<sup className="text-danger">*</sup>
                </strong>
              </label>
              <DatePicker
                value={
                  formData.planned_on
                    ? dayjs(formData.planned_on, "YYYY-MM-DD")
                    : null
                }
                onChange={(date) => {
                  const formattedDate = date ? date.format("YYYY-MM-DD") : "";
                  setFormData((prev: any) => ({
                    ...prev,
                    planned_on: formattedDate, // keep it like in original record
                  }));
                  setErrors((prev: any) => ({ ...prev, planned_on: "" }));
                }}
                format="DD-MM-YYYY" // shows user-friendly format
                className="form-control mt-1 mb-0"
                placeholder="Enter date of training class"
              />
              {errors?.planned_on && (
                <p className="p-0 ps-1 pt-1 text-danger">
                  {errors?.planned_on}
                </p>
              )}
            </div>
            {/* Content */}
            <div className="col-md-6 mb-3">
              <label>
                <strong>
                  Content<sup className="text-danger">*</sup>
                </strong>
              </label>
              <input
                type="text"
                name="contents"
                value={formData.contents}
                onChange={handleChange}
                className="form-control mt-1"
                placeholder="Enter contents"
              />
              {errors?.contents && (
                <p className="p-0 ps-1 pt-1 text-danger">{errors?.contents}</p>
              )}
            </div>
            {/* Start Time */}
            <div className="col-md-6 mb-3">
              <label>
                <strong>
                  Class Start Time<sup className="text-danger">*</sup>
                </strong>
              </label>
              <TimePicker
                name="start_time"
                value={
                  formData.start_time
                    ? dayjs(formData.start_time, "hh:mm")
                    : null
                }
                onChange={(time) => {
                  // console.log("start time", time);
                  setFormData((prev: any) => ({
                    ...prev,
                    start_time: time ? time.format("HH:mm") : "",
                  }));
                  setErrors((prev: any) => ({ ...prev, start_time: "" }));
                }}
                // use24Hours
                format="HH:mm"
                className="form-control mt-1 mb-0"
                placeholder="Enter start time"
              />
              {errors?.start_time && (
                <p className="p-0 ps-1 pt-1 text-danger">
                  {errors?.start_time}
                </p>
              )}
            </div>
            {/* End Time */}
            <div className="col-md-6 mb-3">
              <label>
                <strong>
                  Class End Time<sup className="text-danger">*</sup>
                </strong>
              </label>
              <TimePicker
                name="end_time"
                value={
                  formData.end_time ? dayjs(formData.end_time, "HH:mm") : null
                }
                onChange={(time) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    end_time: time ? time.format("HH:mm") : "",
                  }));
                  setErrors((prev: any) => ({ ...prev, end_time: "" }));
                }}
                // use12Hours
                format="HH:mm"
                className="form-control mt-1 mb-0"
                placeholder="Enter end time"
              />
              {errors?.end_time && (
                <p className="p-0 ps-1 pt-1 text-danger">{errors?.end_time}</p>
              )}
            </div>
            {/* Description */}
            <div className="col-md-6 mb-3">
              <label>
                <strong>
                  Description<sup className="text-danger">*</sup>
                </strong>
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="form-control mt-1"
                placeholder="Enter sub-unit description"
              />
              {errors?.description && (
                <p className="p-0 ps-1 pt-1 text-danger">
                  {errors?.description}
                </p>
              )}
            </div>
            {/* Venue */}
            <div className="col-md-6 mb-3">
              <label>
                <strong>
                  Venue Address<sup className="text-danger">*</sup>
                </strong>
              </label>
              <textarea
                name="venue"
                value={formData.venue}
                onChange={handleChange}
                className="form-control mt-1"
                placeholder="Enter venue address"
              ></textarea>
              {errors?.venue && (
                <p className="p-0 ps-1 pt-1 text-danger">{errors?.venue}</p>
              )}
            </div>
          </div>
          <div className="text-end mt-4">
            <button
              type="submit"
              className="btn btn-primary mx-2"
              disabled={isSubmittingForm}
            >
              {isSubmittingForm ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></div>{" "}
                  Saving...
                </>
              ) : (
                <>{isEditForm ? "Save Changes" : "Add Subunit"}</>
              )}
            </button>
          </div>
        </form>
      </div>
      {/* </Modal> */}
    </div>
  );
};

export default SubunitForm;

//  {/* Objectives */}
//           <div className="col-md-6 mb-3">
//             <label>
//               <strong>
//                 Objectives of Class<sup className="text-danger">*</sup>
//               </strong>
//             </label>
//             <textarea
//               name="objectives"
//               value={formData.objectives}
//               onChange={handleChange}
//               className="form-control mt-1"
//               placeholder="Enter objectives of class"
//             />
//             {errors?.objectives && (
//               <p className="p-0 ps-1 pt-1 text-danger">
//                 {errors?.objectives}
//               </p>
//             )}
//           </div>
//           {/* Skill Prerequisite */}
//           <div className="col-md-6 mb-3">
//             <label>
//               <strong>
//                 Skill Prerequisite<sup className="text-danger">*</sup>
//               </strong>
//             </label>
//             <textarea
//               name="skill_prereq"
//               value={formData?.skill_prereq}
//               onChange={handleChange}
//               className="form-control mt-1"
//               placeholder="Enter skill prerequisite"
//             />
//             {errors?.skill_prereq && (
//               <p className="p-0 ps-1 pt-1 text-danger">
//                 {errors?.skill_prereq}
//               </p>
//             )}
//           </div>
//           {/* Worksheets */}
//           <div className="col-md-6 mb-3">
//             <label>
//               <strong>
//                 Upload Sub-unit Worksheets<sup className="text-danger">*</sup>
//               </strong>
//             </label>
//             <input
//               type="file"
//               name="worksheets"
//               onChange={handleChange}
//               className="form-control mt-1"
//             />
//             {errors?.worksheets && (
//               <p className="p-0 ps-1 pt-1 text-danger">
//                 {errors?.worksheets}
//               </p>
//             )}
//             {formData?.worksheets && (
//               <Link
//                 target="_blank"
//                 to={formData?.worksheets}
//                 className="text-info pt-"
//               >
//                 {formData?.worksheets?.split?.("/").pop()}
//               </Link>
//             )}
//           </div>
//           {/* Assignments */}
//           <div className="col-md-6 mb-3">
//             <label>
//               <strong>
//                 {" "}
//                 Upload Sub-unit Assignments
//                 <sup className="text-danger">*</sup>
//               </strong>
//             </label>
//             <input
//               type="file"
//               name="assignment"
//               onChange={handleChange}
//               className="form-control pt-"
//             />
//             {errors?.assignment && (
//               <p className="p-0 ps-1 pt-1 text-danger">
//                 {errors?.assignment}
//               </p>
//             )}
//             {formData?.assignment && (
//               <Link
//                 target="_blank"
//                 to={formData?.assignment}
//                 className="text-info "
//               >
//                 {formData?.assignment?.split?.("/").pop()}
//               </Link>
//             )}
//           </div>
//           {/* Teacher Material */}
//           <div className="col-md-6 mb-3">
//             <label>
//               <strong>
//                 Upload Teacher Material<sup className="text-danger">*</sup>
//               </strong>
//             </label>
//             <input
//               type="file"
//               name="tchr_material"
//               onChange={handleChange}
//               className="form-control mt-1"
//             />
//             {errors?.tchr_material && (
//               <p className="p-0 ps-1 pt-1 text-danger">
//                 {errors?.tchr_material}
//               </p>
//             )}
//             {formData?.tchr_material && (
//               <Link
//                 target="_blank"
//                 to={formData?.tchr_material}
//                 className="text-info "
//               >
//                 {formData?.tchr_material?.split?.("/").pop()}
//               </Link>
//             )}
//           </div>
